import React, { useEffect, useState } from 'react';
import RefundTable from './RefundTable';
import { getRefundData } from 'services/refund.service';
import RescheduleDialog from './RescheduleDialog';
import RefundPaymentDialog from './RefundPaymentDialog';

const Refund = () => {
	const [showScheduleDialog, setShowScheduleDialog] = useState(false);

	const [refundTableData, setRefundTableData] = useState([]);
	const [selectedRefund, setSelectedRefund] = useState();
	const [showPaymentDialog, setShowPaymentDialog] = useState(false);
	useEffect(() => {
		const userDtails = localStorage.getItem('userDetails');
		const parsedUserDetails = userDtails
			? JSON.parse(userDtails)
			: { id: 1, username: 'root' };
		getRefund(parsedUserDetails?.data?.clientId);
	}, []);

	const getRefund = async (clientId: any) => {
		const refundRespData: any = await getRefundData(clientId);
		setRefundTableData(
			refundRespData && refundRespData?.length > 0 ? refundRespData : [],
		);
	};

	const handleCloseScheduleModal = () => {
		setShowScheduleDialog(false);
	};

	const handleClosePaymentModal = () => {
		setShowPaymentDialog(false);
	};
	const showRescheduleModal = (rescheduleData: any) => {
		setSelectedRefund(rescheduleData);
		setShowScheduleDialog(true);
	};
	const showPaymentModal = (rescheduleData: any) => {
		setSelectedRefund(rescheduleData);
		setShowPaymentDialog(true);
	};

	return (
		<div className="m-3">
			<RefundTable
				data={refundTableData}
				showRescheduleDetails={showRescheduleModal}
				showPayment={showPaymentModal}
			/>
			<RescheduleDialog
				showRescheduleModal={showScheduleDialog}
				handleCloseModal={handleCloseScheduleModal}
				refundData={selectedRefund}
			/>
			<RefundPaymentDialog
				showPaymentDialog={showPaymentDialog}
				handleCloseModal={handleClosePaymentModal}
				refundData={selectedRefund}
			/>
		</div>
	);
};

export default Refund;
